// TODO: Replace with auto generated hook once the configurstion is fixed.
// Run: pnpm generate:openapi && pnpm generate:api
import { useQuery } from '@tanstack/react-query';
import { userBackendClient } from '@repo/api/services/userBackend';

export type SavingsPointsData = {
  username: string;
  savings_points_earned: string;
  savings_points_required: string;
  has_enough_points: boolean;
  has_down_payment_ready: boolean;
  additional_months_at_current: string;
  additional_months_at_downpayment: string;
  additional_downpayment_needed: string;
  excess_points_percentage: string;
  months_at_down_payment: string;
  dip_status: string | null;
  estimated_contact_date: string | null;
  contact_month: string | null;
  eligibility_month: string | null;
  customer_type: string;
  total_investment: string;
  finance_amount: string;
  has_fr_form: boolean;
  first_invested_date: string | null;
  dip_sent_date?: string;
  dip_expiry_date?: string;
  property_value: string | null;
  deposit_percentage: string | null;
  topup_suggestion_amount: string | null;
  topup_contact_month: string | null;
  topup_months_faster: number | null;
  bonus_credits_points: string;
  referral_credits_points: string;
  pfhpp_investment: string;
};

type SavingsPointsResponse = {
  data: SavingsPointsData | Record<string, never>;
};

export const getSavingsPointsQueryKey = () =>
  ['USER_BACKEND', { url: '/savings_points' }] as const;

export function useGetSavingsPoints() {
  return useQuery({
    queryKey: getSavingsPointsQueryKey(),
    queryFn: async () => {
      const res = await userBackendClient<SavingsPointsResponse>({
        method: 'get',
        url: '/savings_points',
      });
      return res.data.data;
    },
  });
}
